

































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { LocationDetailsModule } from "@/store/modules/locationDetails";
import CreateLocationWorkerRequest from "@/models/LocationWorkers/CreateLocationWorkerRequest";
import ListUtils from "@/lib/listUtils";

@Component({
  name: "LocationWorkerCreate",
})
export default class extends GiganautVueDialog {

public request = new CreateLocationWorkerRequest();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new CreateLocationWorkerRequest();
      if (this.workers.length == 0) {
        await LocationDetailsModule.getWorkers();
      }
    }
  }

  get workers() {
    return LocationDetailsModule.workers;
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  get types() {
    return ListUtils.locationWorkerTypes();
  }

  calculateAge(dateOfBirth: Date){
		if (dateOfBirth === null) {
			return "Age Unknown";
		}
		const dob = new Date(dateOfBirth);
		const diff_ms = Date.now() - dob.getTime();
    	const age_dt = new Date(diff_ms); 
  
    	return (Math.abs(age_dt.getUTCFullYear() - 1970) < 18) ? "Under 18" : "";
	}

  async save() {
    await LocationDetailsModule.createLocationWorker(this.request);
    this.dialog = false;
  }
}
